<script>
	import { AppContext } from './Context.svelte.js';

	let ctx = AppContext.get();
</script>

<div class="control-region">
	<fieldset>
		<div class="g-form-field">
			<legend class="sr-only">Chamber:</legend>
			<div class="g-form-field-options">
				{#each ctx.chambers as chamber, i}
					<label
						for="g-toggle-{i}"
						class={[
							'btn btn-custom btn-default',
							ctx.activeChamber === chamber && 'active btn-success',
						]}
					>
						<input
							id="g-toggle-{i}"
							type="radio"
							class="sr-only"
							name="g-chamber"
							value={chamber}
							bind:group={ctx.activeChamber}
						/>
						{chamber}
					</label>
				{/each}
			</div>
		</div>
	</fieldset>
</div>

<style>
	.control-region {
		margin: 1.5rem 0;
	}

	.g-form-field {
		display: flex;
		align-items: center;
		gap: 1ch;
	}

	fieldset {
		margin: 0.5rem 0;
	}

	legend {
		font-size: 1.25rem;
		font-weight: bold;
		color: #42585c;
		width: initial;
		max-width: initial;
	}

	.g-form-field-options {
		display: flex;
		align-items: center;
		gap: 0.25rem;
	}

	label.form-option {
		cursor: pointer;
		padding: 0.5rem 0.75rem;
		font-size: 1.1rem;
	}

	label.form-option.active {
		background-color: #42585c;
		color: #fff;
		font-weight: bold;
	}

	label.form-option.inactive {
		background-color: #ebebeb;
		color: #42585c;
	}

	.sr-only {
		position: absolute;
		width: 1px;
		height: 1px;
		padding: 0;
		margin: -1px;
		overflow: hidden;
		clip: rect(0, 0, 0, 0);
		white-space: nowrap;
		border-width: 0;
	}
</style>
